import { memo } from 'react';
import ConnectedIntegrationCard from './ConnectedIntegrationCard.jsx';

/**
 * A category section on Already Integrated (CT-4160): a header (colored dot from
 * `categoryTokens`, uppercase label, connected count) with the connected cards
 * below. Identical for admin and end user (no role branching).
 *
 * Cards are laid out in a responsive grid rather than wrapped in `CartContainer`:
 * `ConnectedIntegrationCard` (CT-4161) is already a self-contained bordered card,
 * so a `CartContainer` shell would double the border. The dot uses `bg-current`
 * so it inherits the category text-color token (no hex/rgb literals).
 */
function CategoryGroup({ label, colorClass, count, items, onOpenProvider }) {
  return (
    <section className="flex flex-col gap-3">
      <header className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className={`h-2 w-2 rounded-full bg-current ${colorClass || 'text-content-faint'}`}
        />
        <h3 className="text-xs font-semibold uppercase tracking-wide text-content-secondary">
          {label}
        </h3>
        <span className="text-xs text-content-muted">{count}</span>
      </header>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {items.map((view) => (
          <ConnectedIntegrationCard key={view.id} view={view} onOpen={onOpenProvider} />
        ))}
      </div>
    </section>
  );
}

export default memo(CategoryGroup);
